export const STATUS_ALL = 'All statuses'
export const STATUS_ENABLED = 'Active'
export const STATUS_DISABLED = 'Inactive'

export default [STATUS_ALL, STATUS_ENABLED, STATUS_DISABLED]
